import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CollectionDetailsResponse, CollectionsService } from '@src/app/shared/backend/clients';
import { ConfirmationService } from 'primeng/api';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { PermissionService } from '@src/app/shared/services/permission.service';
import { Actions } from '@src/app/shared/backend/auth/Action';
import { DialogReasonComponent } from '@src/app/shared/components/dialog-reason/dialog-reason.component';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';

@Component({
    selector: 'app-view-collection',
    templateUrl: './view-collection.component.html',
    styleUrl: './view-collection.component.scss',
    host: {
        class: 'app-view-collection'
    },
    providers: [ConfirmationService],
    standalone: false
})
export class ViewCollectionComponent extends BaseViewComponent implements OnInit, OnDestroy {

  private readonly destroyedComponent$ = new Subject<void>();

  @ViewChild('dialog') dialog: DialogReasonComponent | undefined;

  delete: boolean = false;
  allowModifyCollection: boolean = false;
  collectionId: number = 0;
  collection: CollectionDetailsResponse = {
    id: 0,
    name: '',
    code: ''
  };

  constructor(
    private permissionService: PermissionService,
    private router: Router,
    private route: ActivatedRoute,
    private collectionsService: CollectionsService) {
    super();
  }

  ngOnInit() {
    this.init();
  }

  private async init(): Promise<void> {
    this.route.params
      .pipe(takeUntil(this.destroyedComponent$))
      .subscribe(async (params) => {
        this.collectionId = Number(params['collectionId']);
        if (this.collectionId > 0) {
          await this.get();
        }
      });

    this.delete = await this.permissionService.hasActionPermissions(Actions.delete);
    this.allowModifyCollection = await this.permissionService.hasActionPermissions(Actions.modify_collections);
  }

  override async get() {
    this.getChild(this.collectionId);
  }

  override async getChild(id: any) {
    try {
      this.collectionId = id;
      this.collection = await firstValueFrom(this.collectionsService.apiCollectionsDetailsIdGet(this.collectionId));
    } catch (error) {
      console.log('Error fetching collection data:', error);
    }
  }

  goToEditCollection() {
    this.router.navigate([`/collections/${this.collectionId}/edit`]);
  }

  async showDeleteDialog(): Promise<void> {
    const deleteCheckResponses = await firstValueFrom(this.collectionsService.apiCollectionsDeleteCheckBatchPost([this.collectionId]));

    this.dialog?.show(deleteCheckResponses);
  }

  async deleteCollection(doDelete: boolean): Promise<void> {
    if (doDelete) {
      await firstValueFrom(this.collectionsService.apiCollectionsDeleteIdDelete(this.collectionId));
      this.router.navigate([`/collections`]);
    }
  }

  ngOnDestroy(): void {
    this.destroyedComponent$.next();
    this.destroyedComponent$.complete();
  }
}
